<div class="container">
  <div class="d-table">
    <div class="d-table-cell">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
